import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { environment } from '../../../environments/environment';

// The function app runs its HTTP triggers at AuthorizationLevel.Function, so Azure
// requires a key on every request before it will invoke the function. The key only
// gets the request past the host; the bearer token MSAL adds is what authorises it.
@Injectable()
export class FunctionKeyInterceptor implements HttpInterceptor {
  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    if (!environment.functionKey || !request.url.startsWith(environment.apiBaseUrl)) {
      return next.handle(request);
    }

    return next.handle(request.clone({ setHeaders: { 'x-functions-key': environment.functionKey } }));
  }
}
